module.exports = __webpack_public_path__ + "img/7_george_h.d8cba098.png";